import axios from 'axios'
import store from '@/store'
import abp from './abp.core';
import _this from '@/main'
// import { MessageBox, Message } from 'element-ui'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 100000
  })

service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.name) {
      config.headers[abp.security.antiForgery.tokenHeaderName] = abp.security.antiForgery.getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptorF
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    return res;
  },
  error => {
    console.log('err' + error) // for debug
    if (error.status === 401) {
      _this.$vs.notification({
        color:'danger',
        position:'top-center',
        title:'错误信息',
        text:'请重新登录',
        icon:"<i class='bx bx-error' ></i>",
        onDestroy:()=>{
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        }
      });
    }
    else{
      let message = ''
      if (error.response && error.response.data && error.response.data.error) {
        message = error.response.data.error.message
      } else {
        message = error.message
      }
      console.log(_this.$vs,'vs');
      _this.$vs.notification({
        // progress: 'auto',
        duration:'none',
        color:'danger',
        position:'top-center',
        title:'错误信息',
        text:message,
      });
    }
   
    return Promise.reject(error)
  }
)

export default service